@import (reference) '../../../../../../constants/spacing.module.less';
@import (reference) '../../../../../../constants/screen-width-breakpoints.module.less';

.modal {
  @media @tablet, @desktop, @widescreen, @ultrawide {
    width: 600px;
    max-height: 545px;
  }
}

.modal-body {
  padding: @space-24;
}

.loading-wrapper {
  position: relative;
  height: 200px;
}
